export interface AppRoute {
  path: string;
  label: string;
}

export const ROUTES = {
  HOME: { path: '/', label: 'Home' },
  ABOUT: { path: '/about', label: 'About' },
  SERVICE: { path: '/service', label: 'Services' },
  PORTFOLIO: { path: '/portfolio', label: 'Portfolio' },
  CAREERS: { path: '/careers', label: 'Careers' },
  CONTACT: { path: '/contact', label: 'Contact' },
  BLOG: { path: '/blog', label: 'Blog' },
} as const;